import { render } from "./Manufacturer.vue?vue&type=template&id=0d41de90"
import script from "./Manufacturer.vue?vue&type=script&scoped=true&lang=js"
export * from "./Manufacturer.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__